export const cellFieldValidationValues = {
  required: 'عنوان سلول الزامی است.',
  pattern: {
    value: /^C\d+$/,
    message: 'عنوان سلول باید به صورت C1، C2، C3 و ... باشد.',
  },
};

export const partFieldValidationValues = {
  required: 'عنوان بخش الزامی است.',
  pattern: {
    value: /^P\d+$/,
    message: 'عنوان بخش باید به صورت P1، P2، P3 و ... باشد.',
  },
};
